import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderBtn,
  SliderDots,
  SliderCount,
} from '@studiometa/ui';

/**
 * Slider component
 */
export default class SliderReassurance extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderItem,
      SliderDrag,
      SliderDots,
      SliderBtn,
      SliderCount,
    },
  };

  /**
   * Mounted
   */
  mounted() {
    super.mounted();
    this.timer();
  }

  /**
   * Set an interval to change slide
   */
  timer() {
    this.interval = setInterval(() => {
      if (this.currentIndex < this.indexMax) {
        this.goNext();
      } else {
        this.goTo(0);
      }
    }, 4000);
  }

  /**
   * On dots click reset interval
   */
  onSliderDotsClick() {
    clearInterval(this.interval);
    this.timer();
  }
}
